import React from 'react'
import { formatPhoneNumberIntl } from 'react-phone-number-input/input'

export function formatPhoneNumberForDisplay(phoneNumberString) {
  if (!phoneNumberString) {
    return ''
  }
  if (phoneNumberString.includes('+1')) {
    return formatPhoneNumberIntl(phoneNumberString)
  }
  return `+1 ${phoneNumberString}`
}

export function formatPhoneNumberForSave(phoneNumberString) {
  return phoneNumberString.replace('+1', '').replace(/\D/g, '')
}

//normalize phone to E.164 for use as react-phone-number-input value (e.g. "+15555555555")
export function formatPhoneNumberToE164(phoneNumberString) {
  if (!phoneNumberString) return ''
  const digits = phoneNumberString.replace(/\D/g, '')
  if (!digits.length) return ''
  if (digits.length === 11 && digits[0] === '1') return `+${digits}`
  if (digits.length >= 10) return `+1${digits.slice(-10)}`
  return `+1${digits}`
}

export default {
  formatPhoneNumberForDisplay,
  formatPhoneNumberForSave,
  formatPhoneNumberToE164,
}
